// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nDTX","tabsBox":"styles_tabsBox__3UbmD","createButton":"styles_createButton__2KVVQ"};